// File Metadata:
// Filename: TrainingProgress.js
// Version: 1.00
// Created: 2025-03-28 19:51:25
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
    Paper, Typography, Box, LinearProgress,
    List, ListItem, ListItemText, ListItemIcon,
    Chip, Tooltip
} from '@mui/material'
import {
    School, CheckCircle, Pending,
    PlayArrow, Block
} from '@mui/icons-material'

const TrainingProgress = ({ program, progress }) => {
    return (
        <Paper sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="h6">Training Progress</Typography>
                <Chip 
                    label={program.type}
                    icon={<School />}
                    color="primary"
                />
            </Box>

            <List>
                {program.modules.map((module, index) => (
                    <ListItem key={index}>
                        <ListItemIcon>
                            {getStatusIcon(module.status)}
                        </ListItemIcon>
                        <ListItemText
                            primary={module.name}
                            secondary={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <LinearProgress 
                                        variant="determinate"
                                        value={module.progress}
                                        sx={{ flexGrow: 1 }}
                                    />
                                    <Typography variant="caption">
                                        {module.progress}%
                                    </Typography>
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Paper>
    )
}

const getStatusIcon = (status) => {
    switch (status) {
        case 'COMPLETED': return <CheckCircle color="success" />
        case 'IN_PROGRESS': return <PlayArrow color="primary" />
        case 'PENDING': return <Pending color="disabled" />
        case 'BLOCKED': return <Block color="error" />
        default: return <Pending />
    }
}

export default TrainingProgress
